import React, { useContext, useState, useEffect } from "react";
import "../../../ui-styles/bottomSlider/BottomSlider.css";
import TxtBtn from "../../../lib/ui/buttons/TxtButton";
import { LangCtx, PayLoadCtx } from "../../../lib/context";
import { createSchedule, updateSchedule } from "../../../actions/schedule";
import { toast } from "react-toastify";
import Loader from "../../../lib/ui/loader/Loader";

const ModalAddDays = (props) => {
    const { l } = useContext(LangCtx);
    const { payload } = useContext(PayLoadCtx);
    const [selDays, setSelDays] = useState([]);
    const [posDays, setPosDays] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (+props.startDate <= +props.endDate) {
            let now = new Date();
            now.setHours(0, 0, 0, 0);
            let _st = new Date(props.startDate);
            _st.setHours(0, 0, 0, 0);
            let st = +props.startDate >= +now ? _st : now;
            let days = [];
            while (+st <= +props.endDate) {
                let _d = Number(st.getDay());
                props.existDays.indexOf(_d) <= -1 && days.push(_d);
                if (days.length === 7) break;
                else st.setDate(st.getDate() + 1);
            }
            setPosDays([...days]);
        }
    }, [props.startDate, props.endDate, props.existDays]);

    useEffect(() => {
        props.selDays ? setSelDays([...props.selDays]) : setSelDays([]);
    }, [props.selDays]);

    const day_data = [
        { id: 0, name: l.sun },
        { id: 1, name: l.mon },
        { id: 2, name: l.tue },
        { id: 3, name: l.wed },
        { id: 4, name: l.thu },
        { id: 5, name: l.fri },
        { id: 6, name: l.sat },
    ];

    const handleDays = (event) => {
        let v = Number(event.target.value);
        let d = [...selDays];
        if (event.target.checked) {
            d.push(v);
        } else {
            d = d.filter((_d) => _d !== v);
        }
        setSelDays([...d]);
    };

    const handleSave = () => {
        setLoading(true);
        if (selDays && selDays.length > 0) {
            let obj = {
                from: props.startDate,
                to: props.endDate,
                days: selDays,
                groupId: props.groupId,
                clinicId: payload.clinicId,
                subdomain: payload.subdomain,
            };
            if (props.id) {
                updateSchedule(obj, props.id)
                    .then((res) => {
                        res.status && res.data && props.loadSch(res.data);
                        setLoading(false);
                    })
                    .catch((err) => {
                        setLoading(false);
                        console.log("err in create schedule ==== ", err);
                        let msg = err?.response?.data?.error
                            ? err.response.data.error
                            : err.errorMessage
                            ? err.errorMessage
                            : l.went_worng_pls_try_again;
                        toast.error(msg, {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                    });
            } else {
                createSchedule(obj)
                    .then((res) => {
                        if (res.status) {
                            props.loadSch();
                        }
                        setLoading(false);
                    })
                    .catch((err) => {
                        setLoading(false);
                        console.log("err in create schedule ==== ", err);
                        let msg = err?.response?.data?.error
                            ? err.response.data.error
                            : err.errorMessage
                            ? err.errorMessage
                            : l.went_worng_pls_try_again;
                        toast.error(msg, {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                    });
            }
        } else {
            // Error
            setLoading(false);
        }
    };

    return (
        <div className={props.openAddDay ? "btmSlider slideUp" : "btmSlider"}>
            <div className="btmSliderPaper miniAuto">
                <div className="btmSliderHdr">
                    <div className="btmHeaderRow">
                        <div className="hdrTxtRow">
                            <span className="hdrTxtL">{l.add_days}</span>
                        </div>
                        <div className="hdrClose" onClick={props.handleAddDays}></div>
                    </div>
                </div>
                <div className="btmSliderBdy">
                    <div className="daysMdlCol">
                        <div className="dcPblock">
                            <p className="pTxt">{l.add_days_desc}</p>
                        </div>
                        <div className="dcPblock">
                            <span>{l.select_days}</span>
                        </div>

                        <div className="hztlScrlBox dcHztlHndl">
                            {day_data.map((day) => (
                                <div
                                    className={`boxMd ripple ${posDays.indexOf(day.id) <= -1 ? "overLay avoidClick" : ""}`}
                                    title={day.name}
                                    key={`selc_${day.id}`}
                                >
                                    <label className="dayCheckbox">
                                        <input type="hidden" name="days" value="False" />
                                        <input
                                            className="dayCheckboxInput"
                                            name="days"
                                            type="checkbox"
                                            value={day.id}
                                            onChange={handleDays}
                                            checked={selDays.indexOf(day.id) > -1}
                                        />
                                        <span className="dayCheckboxText">{day.name}</span>
                                    </label>
                                </div>
                            ))}
                            {/* <div className="boxMd ripple" title="Available">
                                <label className="dayCheckbox">
                                    <input type="hidden" name="days" value="False" />
                                    <input className="dayCheckboxInput" name="days" value="" type="checkbox" />
                                    <span className="dayCheckboxText">Sun</span>
                                </label>
                            </div>
                            <div className="boxMd ripple overLay avoidClick" title="Not Available">
                                <label className="dayCheckbox">
                                    <input type="hidden" name="days" value="False" />
                                    <input className="dayCheckboxInput" name="days" value="" type="checkbox" />
                                    <span className="dayCheckboxText">Mon</span>
                                </label>
                            </div>
                            <div className="boxMd ripple" title="Available">
                                <label className="dayCheckbox">
                                    <input type="hidden" name="days" value="False" />
                                    <input className="dayCheckboxInput" name="days" value="" type="checkbox" />
                                    <span className="dayCheckboxText">Tue</span>
                                </label>
                            </div>
                            <div className="boxMd ripple overLay avoidClick" title="Not Available">
                                <label className="dayCheckbox">
                                    <input type="hidden" name="days" value="False" />
                                    <input className="dayCheckboxInput" name="days" value="" type="checkbox" />
                                    <span className="dayCheckboxText">wed</span>
                                </label>
                            </div>
                            <div className="boxMd ripple" title="Available">
                                <label className="dayCheckbox">
                                    <input type="hidden" name="days" value="False" />
                                    <input className="dayCheckboxInput" name="days" value="" type="checkbox" />
                                    <span className="dayCheckboxText">thu</span>
                                </label>
                            </div>
                            <div className="boxMd ripple" title="Available">
                                <label className="dayCheckbox">
                                    <input type="hidden" name="days" value="False" />
                                    <input className="dayCheckboxInput" name="days" value="" type="checkbox" />
                                    <span className="dayCheckboxText">fri</span>
                                </label>
                            </div>
                            <div className="boxMd ripple overLay avoidClick" title="Not Available">
                                <label className="dayCheckbox">
                                    <input type="hidden" name="days" value="False" />
                                    <input className="dayCheckboxInput" name="days" value="" type="checkbox" />
                                    <span className="dayCheckboxText">sat</span>
                                </label>
                            </div> */}
                        </div>
                    </div>
                </div>
                <div className="dayModFtr">
                    <TxtBtn label={l.cancel} onClick={props.handleAddDays} />
                    <TxtBtn label={l.save} onClick={handleSave} />
                </div>
            </div>
            {loading && <Loader />}
        </div>
    );
};

export default ModalAddDays;
